import React, { useCallback, useEffect, useState } from "react";
import { Input, Flex } from "antd";
import { toast } from "react-toastify";
import { BsMegaphone } from "react-icons/bs";
import { updateCurrentChat } from "../../../../redux/slices/chatSlice";
import { useAppDispatch } from "../../../../redux/utils/Dispatcher";
import { formatSingleChat } from "../../../../utils";
import ENDPOINTS from "../../../../services/endpoint";
import apiInstance from "../../../../services/apiService";
import ChatSidebarHeader from "../../../../components/common/ChatSidebarHeader";
import GradientButton from "../../../../components/common/UI/GradientButton";
import "./index.scss";

const MegaphoneIcon = BsMegaphone as unknown as React.FC;

interface UpdateBroadCastProps {
  broadCastInfo: any;
  handleBackClick: () => void;
}

const UpdateBroadCast: React.FC<UpdateBroadCastProps> = ({
  handleBackClick,
  broadCastInfo,
}) => {
  const dispatch = useAppDispatch();
  const [broadCastName, setGroupName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const fetchBroadCastInfo = useCallback(async () => {
    const URL = ENDPOINTS.CONVERSATION_LIST + `?cId=${broadCastInfo.id}`;

    setLoading(true);
    try {
      const response = await apiInstance.get(URL);
      if (response.status === 200) {
        if (broadCastInfo.isArchived) {
          const conversation = formatSingleChat(
            response.data.newCnv?.docs?.[0]?.archivedList?.[0]
          );
          return conversation;
        } else {
          const conversation = formatSingleChat(
            response.data.newCnv?.docs?.[0]?.conversationList?.[0]
          );
          return conversation;
        }
      }
    } catch (err: any) {
      console.error("Error fetching conversations:", err);
      toast.error(err.message || "There was an error fetching Conversations");
    } finally {
      setLoading(false);
    }
  }, [broadCastInfo]);

  const handleUpdateBroadcast = async () => {
    if (!broadCastName) {
      toast.error("Group name is required");
      return;
    }

    const URL = ENDPOINTS.UPDATE_BROADCAST;
    setLoading(true);

    try {
      const response = await apiInstance.post(URL, {
        chatId: broadCastInfo.id,
        name: broadCastName,
      });

      if (response.status === 200) {
        const updatedDetails = await fetchBroadCastInfo();
        dispatch(
          updateCurrentChat({
            name: updatedDetails?.name,
          })
        );
      }
    } catch (err: any) {
      toast.error(err.message || "Error creating group. Please try again");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (broadCastInfo) {
      setGroupName(broadCastInfo.name);
    }
  }, [broadCastInfo]);

  return (
    <div className="update-broadcast-screen">
      <ChatSidebarHeader
        title="Update Broadcast"
        handleBackClick={handleBackClick}
      />

      <div className="name-container">
        <Flex align="center" gap={10} className="w-full">
          <div className="avatar">
            <MegaphoneIcon />
          </div>
          <Input
            value={broadCastName}
            disabled={loading}
            onChange={(e) => setGroupName(e.target.value)}
            className="custom-input group-name-input"
            placeholder="Group name"
          />
        </Flex>

        <GradientButton
          loading={loading}
          onClick={handleUpdateBroadcast}
          className="update-btn"
        >
          Update
        </GradientButton>
      </div>
    </div>
  );
};

export default UpdateBroadCast;
